import shubinHeaderLogo from "../assets/shubinHeaderLogo.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookSquare,
  faInstagram,
  faSoundcloud,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

const Header: React.FC = () => {
  return (
    <header className="container mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-32 bg-[#000000]">
      <div className="flex items-center">
        <a href="/" aria-label="Home">
          <img
            src={shubinHeaderLogo}
            className="header-logo h-16"
            alt="Shubin Project Logo"
          />
        </a>
      </div>
      <nav className="flex space-x-4" aria-label="Social media links">
        <a
          href="https://soundcloud.com/shubinproject"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visit our SoundCloud page"
        >
          <FontAwesomeIcon
            icon={faSoundcloud}
            className="h-6 w-6 text-[#ebebeb] hover:text-[#C1282DFF]"
          />
        </a>
        <a
          href="https://www.youtube.com/@shubinproject8941"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visit our YouTube channel"
        >
          <FontAwesomeIcon
            icon={faYoutube}
            className="h-6 w-6 text-[#ebebeb] hover:text-[#C1282DFF]"
          />
        </a>
        <a
          href="https://www.facebook.com/shubinproject"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visit our Facebook page"
        >
          <FontAwesomeIcon
            icon={faFacebookSquare}
            className="h-6 w-6 text-[#ebebeb] hover:text-[#C1282DFF]"
          />
        </a>
        <a
          href="https://www.instagram.com/shubin.project/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visit our Instagram page"
        >
          <FontAwesomeIcon
            icon={faInstagram}
            className="h-6 w-6 text-[#ebebeb] hover:text-[#C1282DFF]"
          />
        </a>
      </nav>
    </header>
  );
};

export default Header;
